export const contentTableConfig = {
  title: '统计列表',
  propList: [
    {prop: 'thirdParty', label: '第三方', minWidth: '50'},
    {prop: 'channelName', label: '来源渠道', minWidth: '60'},
    {prop: 'resourcesCount', label: '资源数', minWidth: '50', sortable: true},
    {prop: 'repeatRate', label: '重复率', minWidth: '50', sortable: true, slotName: 'repeatRate'},
    {prop: 'deleteRate', label: '24小时删除率', minWidth: '70', sortable: true, slotName: 'deleteRate'},
    {prop: 'totalDeleteRate', label: '累计删除率', minWidth: '70', sortable: true, slotName: 'totalDeleteRate'},
    {prop: 'invalidNum', label: '重叠数', minWidth: '50', sortable: true},
    {prop: 'thCount', label: '同行数', minWidth: '50', sortable: true},
    // {prop: 'notPreciseCount', label: '非精准数', minWidth: '50', sortable: true},
    {prop: 'openRate', label: '开口率（第二次）', minWidth: '70', sortable: true, slotName: 'openRate'},
    {prop: 'lookRate', label: '看课率（直播）', minWidth: '70', sortable: true, slotName: 'lookRate'},
    {prop: 'dealCount', label: '成交资源数', minWidth: '70', sortable: true, headerTip: '按创建时间统计'},
    {prop: 'succTimeDealCount', label: '成交资源数', minWidth: '70', sortable: true, headerTip: '按成交时间统计'},
    {prop: 'roiRatio', label: '投入产出比', minWidth: '60', sortable: true, slotName: 'roiRatio'},
    {prop: 'monthConversionRate', label: '当月转化率', minWidth: '60', sortable: true, slotName: 'monthConversionRate'},
    {prop: 'lastMonthConversionRate', label: '上月转化率', minWidth: '60', sortable: true, slotName: 'lastMonthConversionRate'},
    {prop: 'accConversionRate', label: '累积转化率', minWidth: '60', sortable: true, slotName: 'accConversionRate'},
  ],
  showIndexColumn: false,
  showSelectColumn: false,
  hideImportData: true
}
